/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'che': {
    width: 6,
    height: 11,
    viewBox: '0 0 6 11',
    data: '<path pid="0" d="M.612 1l4.612 4.612-4.612 4.612" _stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
